import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as Search from '@app/models/search';

@Component({
    selector: 'app-helpers-search-bar-fields-logbook-event',
    templateUrl: './logbook-event.component.html',
    styleUrls: ['./logbook-event.component.scss']
})
export class HelpersSearchBarFieldsLogbookEventComponent{

    @Input() filter: Search.SearchAppliedFilter;
    @Input() style: string = '';
    @Output() remove = new EventEmitter<Search.SearchAppliedFilter>();

    onRemove(filter: Search.SearchAppliedFilter){
        this.remove.emit(filter);
    }

}